import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { CookiesProvider } from "react-cookie";
// import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import App from "./App";
import { configureStore } from "Stores/ConfigureStore";
// import { reCapchaKeySite } from "Constants/Keys";
import "./i18n";

const root = createRoot(document.getElementById("root"));

root.render(
  // <GoogleReCaptchaProvider
  //   reCaptchaKey={reCapchaKeySite}
  //   language="[optional_language]"
  //   useRecaptchaNet="true"
  // >
    <Provider store={configureStore()}>
      <CookiesProvider>
        <App />
      </CookiesProvider>
    </Provider>
  // </GoogleReCaptchaProvider>
);